/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_CapacityInputs */

const en_admin_resources_capacity = /** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacity`)
};

const de_admin_resources_capacity = /** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität`)
};

const es_admin_resources_capacity = /** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad`)
};

const fr_admin_resources_capacity = /** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité`)
};

/** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */
const it_admin_resources_capacity = en_admin_resources_capacity;

/** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */
const pt_br2_admin_resources_capacity = en_admin_resources_capacity;

/** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */
const pl_admin_resources_capacity = en_admin_resources_capacity;

/** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */
const hu_admin_resources_capacity = en_admin_resources_capacity;

/** @type {(inputs: Admin_Resources_CapacityInputs) => LocalizedString} */
const ro_admin_resources_capacity = en_admin_resources_capacity;

/**
* | output |
* | --- |
* | "Capacity" |
*
* @param {Admin_Resources_CapacityInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_capacity = /** @type {((inputs?: Admin_Resources_CapacityInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_CapacityInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_capacity(inputs)
	if (locale === "de") return de_admin_resources_capacity(inputs)
	if (locale === "es") return es_admin_resources_capacity(inputs)
	if (locale === "fr") return fr_admin_resources_capacity(inputs)
	if (locale === "it") return it_admin_resources_capacity(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_capacity(inputs)
	if (locale === "pl") return pl_admin_resources_capacity(inputs)
	if (locale === "hu") return hu_admin_resources_capacity(inputs)
	return ro_admin_resources_capacity(inputs)
});
export { admin_resources_capacity as "admin.resources.capacity" }